// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // optional, if you want to style separately

const Footer = () => {
    return (
        <footer className="HomePage-footer">
            <p>&copy; {new Date().getFullYear()} VictoryLaneAuthentication. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
